module.exports = __webpack_public_path__ + "static/img/poster_5.6115f27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_10/poster_5.jpg
// module id = uAqu
// module chunks = 0